class s extends Error {
  constructor(r, t) {
    super(r), this.location = t, this.name = "ParseError";
  }
}
async function y() {
  const { parse: e } = await import("./parser-BoYMw9bQ.js");
  return {
    parse(r) {
      try {
        return e(r);
      } catch (t) {
        if (t && typeof t == "object" && "location" in t) {
          const i = "message" in t && typeof t.message == "string" ? t.message : String(t);
          throw new s(i, t.location);
        }
        const o = t && typeof t == "object" && "message" in t && typeof t.message == "string" ? t.message : String(t);
        throw new s(o);
      }
    }
  };
}
async function v(e) {
  if (e == null)
    throw new s("DSL source cannot be null or undefined");
  if (typeof e != "string")
    throw new s(`DSL source must be a string, got: ${typeof e}`);
  if (e.trim().length === 0)
    throw new s("DSL source cannot be empty");
  return (await y()).parse(e);
}
class n extends Error {
  constructor(r) {
    super(r), this.name = "CompileError";
  }
}
function $(e) {
  if (!e)
    throw new n("AST is null or undefined");
  if (!e.rules || !Array.isArray(e.rules))
    throw new n("AST rules must be an array");
  if (!e.sourceType || typeof e.sourceType != "string")
    throw new n("AST sourceType must be a non-empty string");
  if (!e.sourceId || typeof e.sourceId != "string")
    throw new n("AST sourceId must be a non-empty string");
  const r = e.rules.map((t) => m(t));
  return {
    version: e.version,
    sourceType: e.sourceType,
    sourceId: e.sourceId,
    rules: r
  };
}
function m(e) {
  return {
    type: e.ruleType,
    name: e.name,
    generate: (r) => e.slides ? e.slides.map((t) => u(t, r)) : e.body ? b(e.body, r) : []
  };
}
function b(e, r) {
  return Array.isArray(e) ? e.map((t) => u(t, r)) : c(e, r);
}
function c(e, r) {
  const t = [];
  if (!e.variable || typeof e.variable != "string")
    throw new n("For loop variable must be a non-empty string");
  const o = a(e.collection, r);
  if (o == null)
    throw new n(
      `For loop collection "${e.collection}" evaluates to ${o === null ? "null" : "undefined"}`
    );
  if (!Array.isArray(o))
    throw new n(
      `For loop collection "${e.collection}" must be an array, got: ${typeof o}`
    );
  for (const i of o) {
    const l = {
      ...r,
      [e.variable]: i
    };
    Array.isArray(e.body) ? t.push(...e.body.map((f) => u(f, l))) : t.push(...c(e.body, l));
  }
  return t;
}
function u(e, r) {
  return {
    content: w(e.content, r),
    behavior: e.behavior ? h(e.behavior, r) : void 0
  };
}
function w(e, r) {
  return e.type === "dynamic" ? {
    type: "dynamic",
    component: e.component,
    props: p(e.props, r)
  } : {
    type: "text",
    lines: e.lines.map((t) => String(a(t, r)))
  };
}
function h(e, r) {
  return {
    transition: {
      type: e.transition.transType,
      ...p(e.transition.options, r)
    }
  };
}
function p(e, r) {
  const t = {};
  for (const [o, i] of Object.entries(e))
    t[o] = a(i, r);
  return t;
}
function a(e, r) {
  if (typeof e == "string")
    return e;
  if (typeof e == "object" && e !== null && "type" in e)
    switch (e.type) {
      case "number":
        return e.value;
      case "boolean":
        return e.value;
      case "member":
        return g(e, r);
      case "binary":
        return d(e, r);
      default:
        throw new n(`Unknown expression type: ${e.type}`);
    }
  throw new n(`Invalid expression: ${JSON.stringify(e)}`);
}
function g(e, r) {
  let t = r[e.object];
  if (e.properties.length === 0) {
    if (t === void 0)
      throw new n(`Variable "${e.object}" is not defined in context`);
    return t;
  }
  const o = [e.object];
  for (const i of e.properties) {
    if (o.push(i), t == null)
      throw new n(
        `Cannot access property "${i}" of "${o.slice(0, -1).join(".")}" because it is ${t === null ? "null" : "undefined"}`
      );
    if (typeof t != "object")
      throw new n(
        `Cannot access property "${i}" of "${o.slice(0, -1).join(".")}" because it is not an object (got ${typeof t})`
      );
    if (!(i in t))
      throw new n(
        `Property "${i}" does not exist on "${o.slice(0, -1).join(".")}"`
      );
    t = t[i];
  }
  return t;
}
function d(e, r) {
  const t = a(e.left, r), o = a(e.right, r);
  switch (e.operator) {
    case "+":
      if (typeof t == "string" || typeof o == "string")
        return String(t) + String(o);
      if (typeof t != "number" || typeof o != "number")
        throw new n(
          `Cannot add ${typeof t} and ${typeof o}. Both operands must be numbers or at least one must be a string.`
        );
      return t + o;
    case "-":
      if (typeof t != "number" || typeof o != "number")
        throw new n(
          `Cannot subtract ${typeof o} from ${typeof t}. Both operands must be numbers.`
        );
      return t - o;
    case "*":
      if (typeof t != "number" || typeof o != "number")
        throw new n(
          `Cannot multiply ${typeof t} and ${typeof o}. Both operands must be numbers.`
        );
      return t * o;
    case "/":
      if (typeof t != "number" || typeof o != "number")
        throw new n(
          `Cannot divide ${typeof t} by ${typeof o}. Both operands must be numbers.`
        );
      if (o === 0)
        throw new n("Division by zero is not allowed");
      return t / o;
    default:
      throw new n(`Unknown operator: ${e.operator}`);
  }
}
export {
  n as CompileError,
  s as ParseError,
  $ as compile,
  y as createParser,
  v as parseSlideDSL
};
//# sourceMappingURL=index.mjs.map
